module.exports.config = {
  apiGateway: {
    URL: "https://xh967twqt2.execute-api.ca-central-1.amazonaws.com/v1",
    AUTH: "https://hxu7elsyhb.execute-api.ca-central-1.amazonaws.com/v1",
    REGION: 'ca-central-1'
  }
}
